/* Layout */
import Layout from '@/layout/index.vue'
import EmptyLayout from '@/layout/empty.vue'

import {RouteConfig} from 'vue-router'
import _ from 'lodash';

const input_features = [
  {title: 'ОК/ХН/Потери', path: 'losses'},
  {title: 'Покупка', path: 'buy'},
  {title: 'Реализация', path: 'sale'},
  {title: 'Транспорт, затраты', path: 'transport_cost'},
  {title: 'Транспорт, выручка', path: 'transport_gain'},
];


const InputRouter: RouteConfig = {
  path: '/input',
  component: Layout,
  redirect: 'noredirect',
  meta: {
    title: 'Заполнение данных',
    icon: 'peoples',
    roles: ['admin', 'operator'],
    alwaysShow: true
  },
  children: _.map(input_features, (x) => {
        return {
          path: x.path,
          // @ts-ignore
          component: () => import(/* webpackChunkName: "inputs" */`@/views/inputs/components/${x.path}/index`),
          name: x.path,
          meta: {
            title: x.title,
            roles: ['admin', 'operator'],
          }
        }
      })
}

export default InputRouter
